var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyProduct(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 73,
    cy: 73,
    r: 73,
    fill: "#61E5E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10487_81071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 126,
    height: 126
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.9998,
    cy: 72.9998,
    r: 62.3689,
    fill: "#73E5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10487_81071)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 72.9998,
    cy: 72.9998,
    r: 62.3689,
    fill: "#39E4B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.607 106.72L106.311 43.2876L36.8545 102.822L83.6312 151.37H150.607V106.72Z",
    fill: "#5B9698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5492 40.4526L51.7385 39.0352L106.311 43.2876L98.1608 44.7051L92.4909 46.8313L39.6899 42.5788L48.5492 40.4526Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 107.429L90.3643 112.39L98.1604 100.696L109.146 107.429Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 107.429L90.3643 112.39L98.1604 100.696L109.146 107.429Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 107.428L106.311 43.2876L98.1602 44.7051V100.695L109.146 107.428Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 107.428L106.311 43.2876L98.1602 44.7051V100.695L109.146 107.428Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1604 44.7051V100.695L90.3643 112.39L92.4905 46.8313L98.1604 44.7051Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1604 44.7051V100.695L90.3643 112.39L92.4905 46.8313L98.1604 44.7051Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8545 102.822L39.6894 42.5791L92.4904 46.8315L90.3642 112.39L36.8545 102.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1036 33.9904C64.0534 36.4866 64.2558 39.7166 64.8184 41.9669C64.9608 42.5365 64.6144 43.1137 64.0448 43.2561C63.4752 43.3985 62.898 43.0522 62.7556 42.4826C62.1691 40.1365 61.8747 36.6433 62.9537 33.6529C61.3855 34.5405 60.1141 35.8134 59.0903 37.2274C56.7508 40.4588 55.8159 44.2713 55.6162 45.2684C55.2974 46.8602 55.4983 47.971 55.7759 48.6374C55.917 48.976 56.0731 49.1896 56.1815 49.3007C56.1956 49.3152 56.208 49.327 56.2185 49.3365C56.6962 49.4408 57.0538 49.8662 57.0538 50.3751C57.0538 50.9623 56.5778 51.4383 55.9907 51.4383C55.6671 51.4383 55.3941 51.3237 55.2046 51.2157C55.0032 51.1008 54.8204 50.9505 54.6592 50.7851C54.3356 50.4532 54.0413 50.0024 53.8133 49.4551C53.3527 48.3496 53.1405 46.8026 53.5314 44.8508C53.7551 43.7343 54.7665 39.5738 57.3681 35.9805C58.6769 34.1729 60.4155 32.4707 62.696 31.393C63.3432 31.0872 64.0286 30.8342 64.7536 30.6436C65.2608 30.1008 65.8595 29.6171 66.5616 29.2157C68.2265 28.2637 70.3793 27.8279 73.0889 28.0537C75.8886 28.287 78.0534 29.3799 79.67 31.0245C81.2687 32.6508 82.2827 34.7651 82.9016 36.9873C84.1346 41.4141 83.8679 46.5139 83.2601 49.8569C83.1551 50.4346 82.6016 50.8178 82.024 50.7127C81.4463 50.6077 81.0632 50.0543 81.1682 49.4766C81.7416 46.3227 81.9711 41.571 80.8534 37.5578C80.297 35.56 79.424 33.8072 78.1538 32.5151C76.9015 31.2412 75.2154 30.3645 72.9123 30.1725C71.6216 30.065 70.5331 30.1317 69.6153 30.324C70.0907 30.3761 70.5782 30.4514 71.0778 30.5513C74.5862 31.253 76.6213 32.6079 77.3742 34.7011C78.0773 36.6557 77.4985 38.9103 76.8452 40.946C76.6734 41.4814 76.4935 42.0099 76.3154 42.5332C75.7711 44.1326 75.2435 45.6828 75.0147 47.2275C74.7219 49.2047 74.9597 50.9684 76.2882 52.5182C76.6703 52.964 76.6186 53.6352 76.1729 54.0173C75.7271 54.3994 75.0559 54.3477 74.6738 53.902C72.8129 51.7309 72.5629 49.2688 72.9115 46.916C73.1714 45.1609 73.7889 43.3497 74.3471 41.7122C74.5139 41.2226 74.6755 40.7487 74.8207 40.2963C75.4951 38.1948 75.8009 36.609 75.3735 35.4208C74.996 34.3713 73.8855 33.2812 70.6608 32.6363C68.8663 32.2774 67.2961 32.2876 65.919 32.5569C65.59 32.9923 65.3209 33.4737 65.1036 33.9904Z",
    fill: "#257FFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProduct);
export default __webpack_public_path__ + "static/media/empty-product.4cc3badc.svg";
export { ForwardRef as ReactComponent };